import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import {
  apiParcelsDetailGet,
  apiParcelsListGet,
} from '@/entities/parcels/modules/api/parcels';
import type { ApiParcelsListParams } from '@/shared/types/api/parcels';

export const useParcelsList = (params: ApiParcelsListParams) =>
  useFetch({
    api: () => apiParcelsListGet(params),
    keywords: queryKeys.parcels.list(params),
    staleTime: 60_000,
  });

export const useParcelDetail = (id: string | undefined) =>
  useFetch({
    api: () => apiParcelsDetailGet(id ?? ''),
    keywords: queryKeys.parcels.detail(id ?? ''),
    enabled: Boolean(id),
    staleTime: 30_000,
  });
